function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M7 0a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7m2.975 8.98v.001a.7.7 0 1 1-.994.987L7 7.987 5.026 9.968a.7.7 0 0 1-.994 0 .7.7 0 0 1 0-.987L6.013 7 4.032 5.019a.7.7 0 0 1 .994-.987L7 6.013l1.974-1.981a.7.7 0 0 1 .994 0 .7.7 0 0 1 0 .987L7.994 7z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-clear-circle.svg";
export { SvgComponent as ReactComponent };